import { FC } from 'react'
import { useGetOne, useUpdate, useNotify, useTranslate } from 'react-admin'
import { useParams } from 'react-router-dom'
import { Node, Edge } from '@xyflow/react'
import { CircularProgress, Box } from '@mui/material'
import { recordToNodes, recordToEdges, nodesToRecord, edgesToRecord } from '../../utils/workflowMapping'
import WorkflowEditorPage from '../../pages/WorkflowEditor/WorkflowEditorPage'
import { WorkflowOut } from '../../types/apiRequests'

const WorkflowEditor: FC = () => {
  const { id } = useParams<{ id: string }>()
  const [update] = useUpdate()
  const notify = useNotify()
  const translate = useTranslate()

  const { data: record, isLoading } = useGetOne<WorkflowOut>(
    'workflow',
    { id: id! },
    { enabled: !!id },
  )

  if (isLoading || !record) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  const initialNodes: Node[] = recordToNodes(record.nodes || [])
  const initialEdges: Edge[] = recordToEdges(record.edges || [])

  const handleSave = (_name: string, nodes: Node[], edges: Edge[]) => {
    void update(
      'workflow',
      {
        id: record.id,
        data: {
          nodes: nodesToRecord(nodes),
          edges: edgesToRecord(edges),
        },
        previousData: record,
      },
      {
        onSuccess: () => {
          // eslint-disable-next-line camelcase
          notify('ra.notification.updated', { type: 'info', messageArgs: { smart_count: 1 } })
        },
        onError: () => {
          notify('ra.notification.http_error', { type: 'error' })
        },
      },
    )
  }

  return (
    <WorkflowEditorPage
      onSave={handleSave}
      initialNodes={initialNodes}
      initialEdges={initialEdges}
      initialName={record.display_name}
      workflowId={record.id}
      testConfig={record.test_config}
    />
  )
}

export default WorkflowEditor
